import { Property } from 'csstype';
import { lazy, Suspense } from 'react';
import { Colors, Typographies } from '../../../theme';
import { Spacing } from '../../../utils';
import { StyledTypography } from './Typography.styles';

const LazyCopy = lazy(() => import('../../molecules/copy/Copy'));

export type TypographyProps = {
  color?: Colors;
  hoverColor?: Colors;
  hoverBodderBottomColor?: Colors;
  gutterBottom?: boolean;
  borderBottomColor?: Colors;
  padding?: Spacing;
  margin?: Spacing;
  type?: Typographies;
  darkMode?: boolean;
  wrapText?: boolean;
  italic?: boolean;
  letterSpacing?: Property.LetterSpacing;
  textAlign?: Property.TextAlign;
  whiteSpace?: Property.WhiteSpace;
  decoration?: Property.TextDecoration;
  overflow?: Property.Overflow;
  copyable?: boolean;
  copyText?: string;
  lineHeight?: Property.LineHeight;
};

export const Typography: React.FC<React.PropsWithChildren<TypographyProps>> = ({
  children,
  type = 'body2',
  color,
  whiteSpace = 'pre-wrap',
  overflow = 'hidden',
  copyable = false,
  copyText,
  lineHeight,
  ...props
}) => {
  return (
    <>
      <StyledTypography
        data-testid="typography"
        type={type}
        color={color}
        whiteSpace={whiteSpace}
        overflow={overflow}
        lineHeight={lineHeight}
        {...props}
      >
        {children}
      </StyledTypography>
      {copyable && (
        <Suspense fallback={<span>...</span>}>
          <LazyCopy
            textToCopy={copyText || (typeof children === 'string' ? children : '')}
            margin={[0, 0, 0, 1]}
          />
        </Suspense>
      )}
    </>
  );
};
